import React from "react";
import Checkbox from "../../components/Checkbox";
import { Control, FieldValues, useController } from "react-hook-form";
import { FormComponent } from "./FormComponent";
import { reactHookFormValidateType } from "../../types/common";

/* eslint @typescript-eslint/no-explicit-any: "off" */

interface CheckboxFieldProps<T extends FieldValues> {
	control: Control<T>;
	checkboxClasses?: string;
	defaultValue?: string;
	label: string | React.ReactNode;
	name: string;
	onInputChange?: (name: string, newInput: string) => void;
	required?: boolean;
	validate?: reactHookFormValidateType;
}

export default function CheckboxField({
	control,
	checkboxClasses,
	defaultValue = "0",
	label,
	name,
	onInputChange,
	required = false,
	validate,
}: CheckboxFieldProps<any>) {
	const {
		field: { value, onChange },
		formState: { errors },
	} = useController({
		name,
		control,
		rules: {
			required,
			validate,
		},
		defaultValue,
	});

	const component = {
		classes: "checkbox-field",
		id: name,
		name,
		required,
		errors,
	};

	const handleToggle = () => {
		const newInput = value === defaultValue ? "1" : defaultValue;
		onChange(newInput);
		onInputChange && onInputChange(name, newInput);
	};

	return (
		<FormComponent {...component}>
			<Checkbox
				checked={value === "1"}
				checkboxClasses={checkboxClasses}
				id={name}
				name={name}
				label={label}
				onToggle={handleToggle}
			/>
		</FormComponent>
	);
}
